export function normalizeWhatsAppPhone(raw: string): string {
  const digits = raw.replace(/[\s+\-()]/g, '');
  return digits.startsWith('56') ? digits : '56' + digits;
}

export function buildWhatsAppUrl(phone: string, message: string): string {
  const normalized = normalizeWhatsAppPhone(phone);
  // Enlace corto oficial: en escritorio ofrece abrir la app instalada y en móvil abre la app
  // directamente. `web.whatsapp.com` forzaba la pantalla de escaneo de QR en escritorio.
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`;
}
